import React from "react";
import {
  Row,
  Col,
  Breadcrumb,
  message,
  Upload,
  InputNumber,
  Divider,
  DatePicker,
} from "antd";
import { Form, Icon, Input, Button, Select, Modal } from "antd";

import Axios from "../../../util/request";

import moment from "moment";
import CarTypeSelect from "../../../components/select/CarTypeSelect";
import GpsSelect from "../../../components/select/GpsSelect";
import { recyclerServices } from "../../../util/publicData";
import { debounce } from "lodash";

const { Option } = Select;
const { TextArea } = Input;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};
const tailLayout = {
  wrapperCol: { offset: 4, span: 16 },
};

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("分类图片请选择 JPG/PNG !");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("分类图片最大 2MB!");
  }
  return isJpgOrPng && isLt2M;
}

class UpdataCar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        title: "提示",
        visible: false,
        width: 600,
        token: null,
        content: function () {
          return <span></span>;
        },
        loading: false,
        userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
      },
      filterData: {},
      imageUrl: "",
      areaList: [],
      committeeCodeList: [],
      fileList: [],
      projectNameMap: [],
      userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
    };
    this.projectNameMap = [];
    if (props.onRef) {
      //如果父组件传来该方法 则调用方法将子组件this指针传过去
      props.onRef(this);
    }
    this.fetchData = debounce(this.fetchData, 800);
  }
  fetchData = (url, type) => {
    const self = this;
    //筛选下拉查询
    Axios({ url, method: "get" }, true).then((result) => {
      if (result.success) {
        let projectNameMap = [];
        projectNameMap = result.data.map((item) => {
          return { label: item.name, value: item.id };
        });
        self.setState({ projectNameMap });
      }
    });
  };

  getUploadToken = (values) => {
    //提交新增用户信息方法
    const self = this;
    Axios(
      {
        url: "/server/admin/qiniu/getUploadToken",
        method: "get",
        data: values,
        type: "json",
      },
      true
    ).then((result) => {
      if (result.success) {
        self.setState({ token: result.uploadToken });
      }
    });
  };

  showDetail = (record) => {
    const { modal } = this.state;
    const self = this;
    this.props.form.resetFields();
    modal.visible = true;
    modal.width = 800;
    modal.loading = false;
    if (record && record.id) {
      modal.title = <span>修改车辆信息</span>;

      const filterData = { ...record };

      let fileListArr = filterData.carDescFile
        ? filterData.carDescFile.split(",")
        : [];
      let fileList = fileListArr.map((d, i) => {
        return {
          uid: i,
          name: "image.png",
          status: "done",
          url: "http://afl-static.aifenlei.com.cn/" + d,
          response: { key: d },
        };
      });

      self.setState({ modal, record, filterData, fileList });
    } else {
      modal.title = <span>新增车辆信息</span>;
      const filterData = {};
      filterData.state = 1;
      self.setState({ modal, filterData, fileList: [] });
    }
  };

  handleCancel = () => {
    const { modal } = this.state;
    modal.visible = false;
    this.setState({ modal });
  };

  handleOk = () => {
    const self = this;
    const { form } = this.props;
    const { filterData, fileList, userInfo } = this.state;
    if (userInfo.projectId) {
      filterData.projectId = userInfo.projectId;
    }
    // const { imageUrl } = this.state;
    // filterData.classifierHeadImg = imageUrl ? imageUrl : "";

    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      if (filterData.id) {
        values.id = filterData.id;
      }
      if (values.insureStartTime) {
        values.insureStartTime = values.insureStartTime.format(
          "YYYY-MM-DD HH:mm:ss"
        );
      } else {
        delete values.insureStartTime;
      }
      if (values.insureEndTime) {
        values.insureEndTime = values.insureEndTime.format(
          "YYYY-MM-DD HH:mm:ss"
        );
      } else {
        delete values.insureEndTime;
      }
      if (values.nextInspectTime) {
        values.nextInspectTime = values.nextInspectTime.format(
          "YYYY-MM-DD HH:mm:ss"
        );
      } else {
        delete values.nextInspectTime;
      }
      if (values.produceTime) {
        values.produceTime = values.produceTime.format("YYYY-MM-DD HH:mm:ss");
      } else {
        delete values.produceTime;
      }
      if (fileList.length > 0) {
        values.carDescFile = fileList.map((d) => {
          return d.response.key;
        });
        values.carDescFile = values.carDescFile.join(",");
      }
      if (values.gpsCid == undefined) {
        values.gpsCid = null;
      }

      Axios(
        {
          url: "/server/admin/car/updateCarInfo",
          method: "post",
          data: values,
          type: "json",
        },
        true
      ).then((result) => {
        if (result.success) {
          message.success("修改成功");
          self.props.fetchOrgData();
          const { modal } = this.state;
          modal.visible = false;
          self.setState({ modal });
        }
      });
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        console.log(values);
      }
    });
  };

  handleChange = (info) => {
    if (info.file.status == "done") {
      this.setState({
        imageUrl: "https://static.aifenlei.com.cn/" + info.file.response.key,
        loading: false,
      });
    }
  };
  getProjectNameMap = () => {
    const self = this;
    Axios(
      {
        // url: "/server/admin/worker/getUserList",
        url: "/server/admin/project/getProjects",
        data: { page: 1, rows: 200, params: JSON.stringify({}) },
        method: "get",
        type: "json",
      },
      true
    ).then((result) => {
      if (result.success) {
        self.projectNameMap = result.data.map((item) => {
          return { label: item.name, value: item.id };
        });
        self.setState({
          projectNameMap: self.projectNameMap,
        });
      }
    });
  };
  componentDidMount() {
    const self = this;
    this.getUploadToken();
    this.getProjectNameMap();
  }

  handleChange2 = (info) => {
    this.setState({ fileList: info.fileList });
  };

  render() {
    const self = this;
    const { filterData, modal, fileList, imageUrl, token, userInfo } =
      this.state;
    const { match } = this.props;
    const { getFieldDecorator } = this.props.form;
    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">车辆图片</div>
      </div>
    );

    return (
      <Modal
        onCancel={this.handleCancel}
        visible={modal.visible}
        width={modal.width}
        title={modal.title}
        footer={[
          <Button key="back" onClick={this.handleCancel}>
            取消
          </Button>,
          <Button key="submit" type="primary" onClick={this.handleOk}>
            确定
          </Button>,
        ]}
      >
        <div>
          <Form
            name="nest-messages"
            style={{ maxWidth: "1000px" }}
            {...layout}
            onSubmit={this.handleSubmit}
          >
            <Row>
              <Col span={24}>
                <Form.Item name={["car", "code"]} label="车牌号">
                  {getFieldDecorator("code", {
                    rules: [{ required: true, message: "请输入车牌号!" }],
                    initialValue: filterData.code,
                  })(
                    <Input
                      placeholder="车牌号"
                      style={{ width: 300 }}
                      onChange={(e) => {
                        const { filterData } = this.state;
                        filterData.code = e.target.value;
                        this.setState({ filterData });
                      }}
                    />
                  )}
                </Form.Item>
                <Form.Item name={["car", "type"]} label="车辆类型">
                  {getFieldDecorator("type", {
                    rules: [{ required: true, message: "请选择车辆类型!" }],
                    initialValue: filterData.type ? filterData.type + "" : "",
                  })(
                    <CarTypeSelect
                      onChange={(val) => {
                        const { filterData } = this.state;
                        filterData.type = val;
                        this.setState({ filterData });
                      }}
                    ></CarTypeSelect>
                  )}
                </Form.Item>

                <Form.Item label="项目">
                  {getFieldDecorator("projectId", {
                    rules: [{ required: true, message: "请选择项目!" }],
                    initialValue:
                      userInfo.projectId != null
                        ? userInfo.projectId
                        : filterData.projectId,
                  })(
                    <Select
                      disabled={userInfo.projectId != null ? true : false}
                      onChange={(val) => {
                        const { filterData } = this.state;
                        filterData.projectId = val;
                        this.setState({ filterData });
                      }}
                      onSearch={(value) => {
                        self.fetchData(
                          "/server/admin/project/getProjects?projectName=" +
                            value
                        );
                      }}
                      onSelect={() => {
                        self.setState({ projectNameMap: self.projectNameMap });
                      }}
                      placeholder="项目"
                      style={{ width: 120 }}
                      allowClear
                      showSearch
                      filterOption={false}
                    >
                      {this.state.projectNameMap.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
                <Form.Item name={["car", "weight"]} label="车辆重量/kg">
                  {getFieldDecorator("weight", {
                    rules: [
                      // { required: true, message: '请输入车辆重量!' },
                    ],
                    initialValue: filterData.weight,
                  })(
                    <InputNumber
                      onChange={(value) => {
                        const { filterData } = this.state;
                        filterData.weight = value;
                        this.setState({ filterData });
                      }}
                      style={{ width: "100%" }}
                      min={0}
                      step={0.01}
                      placeholder="车辆重量/kg"
                    />
                  )}
                </Form.Item>
                <Form.Item
                  name={["car", "insureStartTime"]}
                  label="车辆保险开始日期"
                >
                  {getFieldDecorator("insureStartTime", {
                    rules: [
                      // { required: true, message: '请选择休假起始时间!' },
                    ],
                    initialValue: filterData.insureStartTime
                      ? moment(filterData.insureStartTime)
                      : "",
                  })(<DatePicker placeholder="车辆保险开始日期" />)}
                </Form.Item>
                <Form.Item
                  name={["car", "insureEndTime"]}
                  label="车辆保险结束日期"
                >
                  {getFieldDecorator("insureEndTime", {
                    rules: [
                      // { required: true, message: '请选择休假起始时间!' },
                    ],
                    initialValue: filterData.insureEndTime
                      ? moment(filterData.insureEndTime)
                      : "",
                  })(<DatePicker placeholder="车辆保险结束日期" />)}
                </Form.Item>
                <Form.Item
                  name={["car", "nextInspectTime"]}
                  label="车辆下次年检日期"
                >
                  {getFieldDecorator("nextInspectTime", {
                    rules: [
                      // { required: true, message: '请选择休假起始时间!' },
                    ],
                    initialValue: filterData.nextInspectTime
                      ? moment(filterData.nextInspectTime)
                      : "",
                  })(<DatePicker placeholder="车辆下次年检日期" />)}
                </Form.Item>
                <Form.Item name={["car", "produceTime"]} label="车辆生产日期">
                  {getFieldDecorator("produceTime", {
                    rules: [
                      // { required: true, message: '请选择休假起始时间!' },
                    ],
                    initialValue: filterData.produceTime
                      ? moment(filterData.produceTime)
                      : "",
                  })(<DatePicker placeholder="车辆生产日期" />)}
                </Form.Item>
                <Form.Item name={["car", "gpsCid"]} label="GPS设备号">
                  {getFieldDecorator("gpsCid", {
                    rules: [
                      // { required: true, message: '请选择车辆类型!' },
                    ],
                    initialValue: filterData.gpsCid
                      ? filterData.gpsCid + ""
                      : "",
                  })(
                    <GpsSelect
                      onChange={(val) => {
                        const { filterData } = this.state;
                        filterData.gpsCid = val;
                        this.setState({ filterData });
                      }}
                    ></GpsSelect>
                  )}
                </Form.Item>
                <Form.Item name={["car", "state"]} label="状态">
                  {getFieldDecorator("state", {
                    initialValue: filterData.state + "",
                  })(
                    <Select
                      onChange={(val) => {
                        const { filterData } = this.state;
                        filterData.state = val;
                        this.setState({ filterData });
                      }}
                      style={{ width: 300 }}
                    >
                      <Option key={1} value={"1"}>
                        正常
                      </Option>
                      <Option key={0} value={"0"}>
                        禁用
                      </Option>
                    </Select>
                  )}
                </Form.Item>

                <Divider dashed={true} />
                <Form.Item name={["car", "carDescFile"]} label="车辆图片">
                  <Upload
                    multiple
                    name="file"
                    data={(file) => ({
                      token,
                      key: "/huanwei/car/" + (new Date().getTime() + file.name),
                    })}
                    action="https://upload-z1.qiniup.com"
                    listType="picture-card"
                    fileList={fileList}
                    // onPreview={this.handlePreview}
                    onChange={this.handleChange2}
                  >
                    {uploadButton}
                    {/*{fileList.length >= 8 ? null : uploadButton2}*/}
                  </Upload>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    );
  }
}
export default Form.create({ name: "submit" })(UpdataCar);
